import { ReactComponent as ThumbsUp } from 'assets/images/videoReactions/thumbsUp.svg';
import styled from 'styled-components/macro';

const ThumbsUpIcon = styled(ThumbsUp)`
  width: ${props => props.width || '24px'};
  height: ${props => props.height || '24px'};
`;

export default ThumbsUpIcon;
